// @flow
import React, { useState, useMemo, useCallback } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'react-redux'

import { FilterDataProvider } from 'app/common/ui-components/filter'
import { Space } from 'app/common/layouts/RowLayout'

import ReportFilter, { filterItems } from './ReportFilter'
import ReportGenerate from './ReportGenerate'
import Report from './Report'
import { saveSettingsKey } from 'app/common/actions/settings/save'

const Sales = () => {
  const dispatch = useDispatch()

  const email: string | null = useSelector((state) => state.user.email, shallowEqual)
  const splitByDays = useSelector((state) => state.settings.reportSales.splitByDays, shallowEqual)
  const saveSplitByDays = useCallback(
    (checked: boolean) => dispatch(saveSettingsKey('reportSales', { splitByDays: checked })),
    [dispatch],
  )

  const filterParams = useMemo(() => ({ email, splitByDays }), [email])

  const [reportId, setReportId] = useState<null | number>(null)

  return (
    <FilterDataProvider filters={filterItems} params={filterParams}>
      <ReportGenerate onGenerate={setReportId}>
        {(processing) => (
          <ReportFilter loading={processing} onChangeSplitByDays={saveSplitByDays} />
        )}
      </ReportGenerate>
      <Space />
      <Report reportId={reportId} />
    </FilterDataProvider>
  )
}

export default Sales
